import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'antd';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useDispatch, useSelector } from 'react-redux';
import { getPermissionGroups } from 'store/actions'; // Assuming you have an action to fetch permission groups

const CreatePermission = ({ visible, handleClose, initialData = '', onSubmit }) => {
    const dispatch = useDispatch();

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            permissionName: initialData?.permissionName || '',
            pageUrl: initialData?.pageUrl || '',
            permissionGroup: initialData?.permissionGroup || '',
        },
        validationSchema: Yup.object({
            permissionName: Yup.string().required('Permission Name is required'),
            pageUrl: Yup.string().required('Page URL is required'),
            permissionGroup: Yup.string().required('Permission Group is required'),
        }),
        onSubmit: (values, { resetForm }) => {
            if (initialData?.permissionName) {
                onSubmit({
                    sp: 'usp_UpdatePermission',
                    ...values,
                    permissionId: initialData?.permissionId,
                });
                onClose();
            } else {
                onSubmit({
                    sp: 'usp_InsertPermission',
                    ...values,
                });
                onClose();
            }
        },
    });

    const onClose = () => {
        formik.resetForm();
        handleClose();
    };

    return (
        <Modal
            title={initialData ? 'Edit Permission' : 'Create New Permission'}
            visible={visible}
            onCancel={onClose}
            footer={null}
            destroyOnClose
            centered
            width={600}
            className="custom-modal-header p-0"
            maskClosable={false}
        >
            <form onSubmit={formik.handleSubmit}>
                <div role="document">
                    <div className="row g-3">
                        <div className="col-md-12">
                            <label className="form-label fs-7">Permission Name</label> <span className='text-danger'>*</span>
                            <input
                                type="text"
                                className="form-control form-control-md form-control-solid fs-7 bg-body-secondary"
                                placeholder="Enter permission name"
                                name="permissionName"
                                value={formik.values.permissionName}
                                onChange={formik.handleChange}
                            />
                            {formik.touched.permissionName && formik.errors.permissionName && (
                                <span style={{ color: 'red' }} role="alert">{formik.errors.permissionName}</span>
                            )}
                        </div>

                        <div className="col-md-12">
                            <label className="form-label fs-7">Page URL</label> <span className='text-danger'>*</span>
                            <input
                                type="text"
                                className="form-control form-control-md form-control-solid fs-7 bg-body-secondary"
                                placeholder="Enter page URL"
                                name="pageUrl"
                                value={formik.values.pageUrl}
                                onChange={formik.handleChange}
                            />
                            {formik.touched.pageUrl && formik.errors.pageUrl && (
                                <span style={{ color: 'red' }} role="alert">{formik.errors.pageUrl}</span>
                            )}
                        </div>

                        <div className="col-md-12">
                            <label className="form-label fs-7">Permission Group</label> <span className="text-danger">*</span>
                            <input
                                type="text"
                                className="form-control form-control-md form-control-solid fs-7 bg-body-secondary"
                                placeholder="Enter permission group"
                                name="permissionGroup"
                                value={formik.values.permissionGroup}
                                onChange={formik.handleChange}
                            />
                            {formik.touched.permissionGroup && formik.errors.permissionGroup && (
                                <span style={{ color: 'red' }} role="alert">{formik.errors.permissionGroup}</span>
                            )}
                        </div>
                    </div>

                    <div className="modal-footer mt-3">
                        <button type="button" className="btn btn-light" onClick={onClose}>
                            Close
                        </button>
                        <button type="submit" className="btn btn-primary ms-3">
                            {initialData ? 'Update' : 'Add'}
                        </button>
                    </div>
                </div>
            </form>
        </Modal>
    );
};

CreatePermission.propTypes = {
    visible: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
    initialData: PropTypes.object,
    onSubmit: PropTypes.func.isRequired,
};

export default CreatePermission;
